import Element from "./base/element";
import Collapsible from "./base/collapsible";

class MultCoachesCollapsible extends Collapsible {
	constructor(props) {
		super(props);
	}

	handleToggleCollapsible() {
		if (window.matchMedia('(max-width: 768px)').matches) {
			this.toggleCollapsible();
		}
	}
}

export default class MultCoachesBar extends Element {
	constructor(props) {
		super(props);

		this.init();
	}

	init() {
		const $items = this.$root.querySelectorAll('.mult-coaches-bar_item');

		$items.forEach(($item) => {
			const $tip = $item.querySelector('.mult-coaches-bar_tip');
			$tip.style.left = `calc(50% - ${$tip.offsetWidth / 2}px)`;
		});

		this.collapsible = new MultCoachesCollapsible({ $root: this.$root });

		super.init();
	}
}